import { ACCESS_TOKEN_STORAGE_NAME } from '../constants';

export const readAccessToken = (): string | null => {
  return window.localStorage.getItem(ACCESS_TOKEN_STORAGE_NAME) || null;
};

export const writeAccessToken = (token: string | null): void => {
  if (token === null) {
    window.localStorage.removeItem(ACCESS_TOKEN_STORAGE_NAME);
    return;
  }

  window.localStorage.setItem(ACCESS_TOKEN_STORAGE_NAME, token);
};
